import { FunctionComponent, PropsWithChildren } from "react";
import { IonCol, IonGrid, IonRow } from "@ionic/react";

export const EditPlaceholderSiteList: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => (
  <IonGrid style={{ height: "100%" }}>
    <IonRow style={{ height: "100%" }} className="ion-align-items-center">
      <IonCol style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>{children}</IonCol>
    </IonRow>
  </IonGrid>
);
